module.exports = __webpack_public_path__ + "static/drt7-925650fb3f59f70b52d596d8cc730db4.jpg";